import React from "react";
import { Tooltip, Typography } from "antd";
import { WARNING_700, WARNING_100 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export const WaitList = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      overlayInnerStyle={{ borderRadius: 0 }}
      title={t("patientPotentialSavings.waitlist_tooltip")}
      placement={"top"}
    >
      <div
        {...props}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: WARNING_100,
          padding: "2px 6px",
          borderRadius: 4,
          gap: 5
        }}
      >
        <Text
          style={{
            fontSize: sizes.xsmall,
            fontWeight: fontWeights.semibold,
            color: WARNING_700,
            textTransform: "uppercase"
          }}
        >
          {t("patientPotentialSavings.waitlist")}
        </Text>
      </div>
    </Tooltip>
  );
};
